
/* 
=============================================================================
SET GLOBAL VARIABLES
============================================================================= 
*/

var firstload;
var viewport = updateViewportDimensions();
var globalStatus = "closed";
var menuStatus = "closed";
var overlayStatus = "closed";
var winInitHeight = viewport.height;
/* how long to wait before deciding the resize has stopped, in ms. 
Around 50-100 should work ok. */
var timeToWaitForLast = 30;

var $window = $(window),
win_height_padded = $window.height() * 1.1,
isTouch = Modernizr.touch;

/* 
=============================================================================
CACHE KEY ELEMENTS
============================================================================= 
*/

$html = $("html");
$body = $("body");
$header = $(".header");
$main_menu = $(".main-menu");
$toggle_menu = $(".toggle-menu");
$footer = $(".footer");
$globals = $(".globals");
$global_section = $(".global");
$pagination = $(".pagination");
$right_overlay = $(".right-overlay");



/* 
=============================================================================
GET VIEWPORT DIMENSIONS 
BASED ON https://github.com/eddiemachado/bones/blob/master/library/js/scripts.js
returns object with viewport dimensions to match css in width and height properties
============================================================================= 
*/

function updateViewportDimensions() {
	var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
	return { width:x,height:y };
}

/* 
=============================================================================
DETERMINE WHETHER DESKTOP OR MOBILE VERSION TO BE USED
============================================================================= 
*/

function determineVersion(){
  //console.log("determineVersion");
  //console.log(viewport.width, viewport.height);
  if( viewport.width >= 1280 ) {
    displayDesktopVersion();
  } 
  else {
    displayMobileVersion(); 
  }
}

/* 
=============================================================================
DESKTOP VERSION 
============================================================================= 
*/

function displayDesktopVersion() {
  //console.log("displayDesktopVersion"); 
  $html.removeClass("mobile").addClass("desktop");
  /*remove all all inline styles*/
  $('.grid-item').attr('style', function(i, style)
  {
      return style.replace(/display[^;]+;?/g, '');
  }); 
  //move sign-up form from footer to about section on desktop only
  $("#about .sign-up").prepend($(".cmApp_embedFormContainer"));
  $(".footer .sign-up .cmApp_embedFormContainer").detach();

  if($body.hasClass("template-index")) {
    $(".footer .store-info").appendTo($("#store-info-container2")); 
    $("#store-info-container3").html(storeInfo);
    $(".header .main-menu").appendTo($(".navigation-bar.desktop")); 
  } 
  else{
    $(".footer .store-info").appendTo($(".header #store-info-container"));
  }

  fadeInElements();
} 


/* 
=============================================================================
MOBILE VERSION 
============================================================================= 
*/

function displayMobileVersion() {
  //console.log("displayMobileVersion");    
  $html.removeClass("desktop").addClass("mobile");
  /*remove all all inline styles*/
  $('.grid-item').attr('style', function(i, style){
      return style.replace(/display[^;]+;?/g, '');
  }); 
  //move sign-up form from about section to footer on mobile only
  $(".footer .sign-up").prepend($(".cmApp_embedFormContainer"));
  $("#about .sign-up .cmApp_embedFormContainer").detach();  

  if($body.hasClass("template-index")) {
    $(".footer .store-info").appendTo($("#store-info-container2")); 
    $("#store-info-container3").html(storeInfo);
    $(".main-content .navigation-bar.desktop .main-menu").appendTo($(".header .navigation-bar")); 
  } 
  else{
    $(".footer .store-info").appendTo($(".header #store-info-container"));
  }

  fadeInElements(); 
}


/* 
=============================================================================
FADE IN CONTENT ONCE ADJUSTMENTS HAVE BEEN MADE
============================================================================= 
*/

function fadeInElements(){
  //console.log("fadeInElements");
  //stops ugly jumping in mobile browsers on 100vh elements when scroll
  winInitHeight = viewport.height;
  //alert(viewport.height);
  if(firstload == true){
    //console.log(viewport.width, viewport.height);
    if($html.hasClass("touch")){
      $body.css("min-height",winInitHeight);
      $("#wrapper").css("min-height",winInitHeight);
      $(".main").css("min-height",winInitHeight);
      //$(".hero-image").css("min-height",winInitHeight);
      $(".home-hero").css("height",winInitHeight);
      //$(".hero").css("margin-top",winInitHeight);
    }
  };  
  $body.removeClass('loading').addClass('loaded');
  //console.log("menuStatus",menuStatus);
  if(menuStatus == "open"){
    //console.log("close everything");
    closeMenu();
  }    
} 


/* 
=============================================================================
CLOSE AND OPEN FUNCTIONS
============================================================================= 
*/

function closeMenu(){
  $main_menu.removeClass("open");
  $toggle_menu.removeClass("open");
  $body.removeClass("menu-open");
  $header.removeClass("menu-open");
  $body.removeClass("noscroll");
  $globals.removeClass("section-open");
  $global_section.removeClass("open");
  menuStatus = "closed";
}

function openMenu(){
  $main_menu.addClass("open");
  $toggle_menu.addClass("open");
  $body.addClass("menu-open");
  $header.addClass("menu-open");
  $global_section.removeClass("open");
  $body.addClass("noscroll");
  menuStatus = "open";
} 

function closeGlobals(){
  $globals.removeClass("section-open");
  closeMenu();
  $body.removeClass("globals-open");
  globalStatus = "closed";
}   


/* 
=============================================================================
THROTTLE RESIZE TRIGGERED EVENTS
source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
============================================================================= 
*/

var waitForFinalEvent = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
		if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();


$(window).resize(function () {
  waitForFinalEvent( function() {
    //update the viewport, in case the window size has changed
    viewport = updateViewportDimensions();
    //other functions to fire when window resizes go here
    firstload = false;
    determineVersion();
  }, 
  timeToWaitForLast,"your-function-identifier-string");

});


/* 
=============================================================================
SCROLL EVENTS
============================================================================= 
*/

$(window).scroll(function () {
  var speed = 2;
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var yPos = 0 - scrollTop / speed;
  //console.log(yPos);
  $(".desktop .parallax").css("top", yPos +"px"); 

  //if at the top of the document, else...
  if($(window).scrollTop() === 0) {
    $(".scroll-indicator").stop().fadeIn();    
    $header.removeClass("have-scrolled");    
  } else {
    $(".scroll-indicator").stop().fadeOut();      
    $header.addClass("have-scrolled");
  } 
      
  //if paged down one scheen height, else...
  if ($(window).scrollTop() > winInitHeight) {
      //console.log("paged down once");
      $pagination.addClass("stuck");
  } else {
      $pagination.removeClass("stuck");
  }       

  //nothing here for now
  /*  waitForFinalEvent( function() { 
  
  }, 
  timeToWaitForLast,"your-function-identifier-string");
  */
});



/* =============================================================================
  DOCUMENT READY
============================================================================= */  

jQuery(document).ready(function($) {

    loopValue = false;
    firstload = true;
    viewport = updateViewportDimensions();
    storeInfo = $("footer .store-info").html();
    determineVersion();
    if(window.location.href.indexOf("?contact_posted=true") > -1) {
       $("#quoteForm").addClass("open success"); 
       $("#contact_form p").css("display","none"); 
       $("#contact_form .form-success ").css("display","block");  
       $body.addClass("overlay-open");
       overlayStatus = "open";
    }  
    //Add focus to form inouts if a label is tapped/clicked
    var labelID;
    $('label').click(function() {
           labelID = $(this).attr('for');
           //console.log("label clicked for", labelID);
           $('#'+labelID).focus();
    });    

    /* =============================================================================
      BIND SWIPEBOX ON EVERY LINK WITH SWIPEBOX CLASS (FURNITURE PRODUCT PAGE)
    ============================================================================= */    

    /*if (window.location.href.indexOf("#cart") > -1) {
        console.log("open cart");
        ajaxCart.load();
        loadCart();
        timber.RightDrawer.open();        
    }
    */

    console.log("ready");
    $(".desktop .parallax").css("top",0);     


    /* =============================================================================
      BIND SWIPEBOX ON EVERY LINK WITH SWIPEBOX CLASS (FURNITURE PRODUCT PAGE)
    ============================================================================= */    

    $( '.swipebox' ).swipebox( {
      afterOpen: function() {
        $("#swipebox-overlay").addClass("open");
      }, 
      afterClose: function() {
        $("#swipebox-overlay").removeClass("open");
      }, 
    });


    /* =============================================================================
      BIND MAIN MENU BEHAVIOURS TO HEADER - THIS CONTROLS DESKTOP AND MOBILE EVENTS
    ============================================================================= */    

    $header.bind({
      mouseenter: function() {
        //desktop only
        if($html.hasClass("desktop")){
          //console.log("yes has desktop class");      
          //if menu and glbals are both closed
          if(menuStatus == "closed" && globalStatus == "closed"){
            openMenu();
          }        
        }
      },
      mouseleave: function() {
        //desktop only
        if($html.hasClass("desktop")){
          //if menu is open but globals are closed
          if(menuStatus == "open" && globalStatus == "closed"){
            closeMenu();
          }       
        }
      },
      click: function() {  
        //console.log("mouse click");
        //mobile only
        if($html.hasClass("mobile")){
          if(menuStatus == "closed" && globalStatus == "closed"){
            //console.log("menus and overlays are closed so open menu");
            openMenu();
          }
          else if(menuStatus == "open" && globalStatus == "closed"){
            //console.log("menu is open and overlays are closed so can close menu");
            closeMenu();
          }  
        } 
      }
    });


    /* =============================================================================
      LINKS IN MAIN MENU WHICH OPEN A HIDDEN SECTION IN AN OVERLAY
    ============================================================================= */    

    $(".overlay-trigger").on('click', function(e){
      e.preventDefault();
      //override document click event, i.e. if click anywhere
      e.stopPropagation();    
      closeMenu();
      var hash = this.hash; 
      //open relevant section in globals       
      $globals.addClass("section-open");
      $(hash).addClass("open");
      //turn off scrolling on main
      $body.addClass("globals-open");
      globalStatus = "open";
    }); 

    //once a global section is open, and click inside it, override document click event
    $global_section.on('click', function(e){
      e.stopPropagation();
    });  

    

    /* =============================================================================
      CLOSING ELEMENTS BY CLICKING ANYWHERE
      (EXCEPT WHEN AN OVERRIDE IS IN PLACE USING STOP PROPOGATION, SEE NEXT FEW FUNCTIONS)
    ============================================================================= */    


    $(document).click( function(){    
      //console.log("document clicked");
      //close right overlays
      /*
      if($html.hasClass("desktop") == true && overlayStatus == "open"){
        $right_overlay.removeClass("open");
        $body.removeClass("overlay-open");        
        overlayStatus = "closed";
      }
      */
      //close globals
      if($html.hasClass("desktop") == true && globalStatus == "open"){
        $globals.removeClass("section-open");      
        $body.removeClass("globals-open");
        globalStatus = "closed";
        closeMenu();
      }
    }); 

    $('.main-content').click( function(){    
      //console.log(".main-content clicked");
      //close right overlays
      if($html.hasClass("desktop") == true && overlayStatus == "open"){
        $right_overlay.removeClass("open");
        $body.removeClass("overlay-open");        
        overlayStatus = "closed";
      }
    });     


    /* =============================================================================
      TRIGGERS FOR CLOSING GLOBALS 
    ============================================================================= */    
    
    //MOBILE IF CLICK ON TOP BAR
    $(".global .top-bar").on('click', function(e){
      e.preventDefault();
      $(this).parent().removeClass("open");
      closeGlobals();
    });

    //DESKTOP IF CLICK ON CLOSE BTN
    $(".close-globals ").on('click', function(e){
      e.preventDefault();
      $(this).parent().removeClass("open");
      closeGlobals();
    });


    //CLOSE MENU IF CLICK ON CART IN NAV
    $(".cart a ").on('click', function(e){
      //console.log("cart clicked");
      closeMenu();
    });    


    /* =============================================================================
      TRIGGERS FOR OPENING RIGHT SIDE OVERLAYS 
    ============================================================================= */    

    $("#contact_form").on('click', function(e){
      e.stopPropagation();
      //console.log("form clicked");    
    }); 

    $("#contact_form").submit(function(e) {
      //e.preventDefault();
      e.stopPropagation();
      //console.log("form submitting");
      if(window.location.href.indexOf("?contact_posted=true") > -1) {
         $("#quoteForm").addClass("open success");      
         $body.addClass("overlay-open");
         overlayStatus = "open";
         $("#contact_form .form-row").css("display","none");
         $("#contact_form p").css("display","none"); 
         $("#contact_form .form-success ").css("display","block"); 
      }    
    }); 


   
    $(".quoteBtn").on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      //console.log("right-overlay open");
      $("#quoteForm").addClass("open");
      $body.addClass("overlay-open");
      overlayStatus = "open";
    }); 

    $(".shippingBtn").on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      //console.log("overlay open");
      $("#shipping").addClass("open");
      $body.addClass("overlay-open");
      overlayStatus = "open";
    });     

    $(".overlay-close").on('click', function(e) {
        $right_overlay.removeClass("open");
        $body.removeClass("overlay-open");
        overlayStatus = "closed";
    });   

    //MOBILE IF CLICK ON TOP BAR
    $(".right-overlay .top-bar").on('click', function(e){
        $right_overlay.removeClass("open");
        $body.removeClass("overlay-open");
        overlayStatus = "closed";
    });

    /* =============================================================================
      JOURNAL - CLICK TO OPEN/CLOSE POST TEXT OVER IMAGE
    ============================================================================= */    

    $(".trigger-text .image-container").on('click', function(e){
        var post = $(this).parent();
        $(".trigger-text").removeClass("open"); 
        post.addClass("open");  
    }); 

    $(".trigger-text .post-text").on('click', function(e){
        var post = $(this).parent().parent();
        post.removeClass("open"); 
    });  



      /* =============================================================================
      SMOOTH SCROLLING TO ANCHOR ON SAME PAGE
    ============================================================================= */  

    $('.main-content a[href^="#"]').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      if(target != ""){
        var $target = $(target);
        }
      if($target){
          $('html, body').stop().animate({
              'scrollTop': $target.offset().top
          }, 800, 'swing', function () {
              window.location.hash = target;
      });
      }
    });

    $('.smooth').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      if(target != ""){
        var $target = $(target);
        }
      if($target){
          $('html, body').stop().animate({
              'scrollTop': $target.offset().top
          }, 400, 'swing', function () {
              window.location.hash = target;
      });
      }
    });  

  });

/* =============================================================================
  HOMEPAGE RANDOM HERO IMAGE
  On load, get a different image for the hero image.
============================================================================= */  

if(document.body.id === "bautier"){
  const heroImages = document.querySelectorAll(".randomHero");
  const randNum = Math.floor(Math.random() * 10) + 1;

  if(heroImages[randNum].src.includes('no-image')){
    heroImages[0].classList.add("selected");
  } else {
    heroImages[randNum].classList.add("selected");
  };
};

/* =============================================================================
  COLLECTION FILTERS
============================================================================= */ 

function filterCollection(tag){
  const products = document.querySelectorAll(".product");
  const filteredProducts = document.querySelectorAll(`.${tag}`);

  if(tag !== "product"){
    products.forEach(product => {
      product.classList.add('hide');
    })
    filteredProducts.forEach(product => {
      product.classList.remove('hide');
    })
  } else {
    products.forEach(product => {
      product.classList.remove('hide');
    })
  }
};

function filterPosts(tag){
  const products = document.querySelectorAll(".post");
  const filteredProducts = document.querySelectorAll(`.${tag}`);

  if(tag !== "post"){
    products.forEach(product => {
      product.classList.add('hide');
    })
    filteredProducts.forEach(product => {
      product.classList.remove('hide');
    })
  } else {
    products.forEach(product => {
      product.classList.remove('hide');
    })
  }
};

function addActiveClass(tag){
  const buttons = document.querySelectorAll(".filter-tags-button");
  buttons.forEach(btn => {
    btn.classList.remove('active');
  })
  document.querySelector(`#${tag}`).classList.add('active')
}

/* =============================================================================
  END OF DOCUMENT READY
============================================================================= */  